import { Switch } from 'aos-ui-universal'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { TaskOrTemplatePayload } from '../../../utils'
import { TaskFormField } from '../TaskFormField'

export const TaskBillableField = () => {
    const { t: translate } = useTranslation()
    const { control, trigger } = useFormContext<TaskOrTemplatePayload>()

    return (
        <Controller
            control={control}
            name='billable'
            render={({ field }) => (
                <TaskFormField
                    label={translate('form.maintenance.billable.label', { ns: 'tasks' })}
                >
                    <Switch
                        value={field.value}
                        onValueChange={v => {
                            field.onChange(v)
                            if (!v) {
                                void trigger('description')
                            }
                        }}
                    />
                </TaskFormField>
            )}
        />
    )
}
